import { Box, Flex, Text } from "@chakra-ui/react";
import SupportUsersIcon from "assets/img/support/support-users.svg";
import { memo } from "react";
import { MessageAttachments } from "./MessageAttachments";
import { MessageFailedStatus } from "./MessageFailedStatus";

type Props = {
  message: any;
  currentCustomerId?: string;
  otherPartyLabel?: string;
  displayTime: string;
  onRetrySend?: (clientId: string) => void;
  getId: (m: any) => string;
  getBody: (m: any) => string;
  getDisplayName: (url: string, att?: any) => string;
  onDownload: (url: string, displayName: string) => void;
};

export const MessageItem = memo(function MessageItem({
  message,
  currentCustomerId,
  otherPartyLabel,
  displayTime,
  onRetrySend,
  getId,
  getBody,
  getDisplayName,
  onDownload,
}: Props) {
  const m = message;
  const id = getId(m);
  const body = getBody(m);

  const senderValue = m?.sender_id ?? m?.sender ?? m?.senderId ?? m?.senderID;
  const isMine =
    currentCustomerId != null &&
    senderValue != null &&
    String(senderValue) === String(currentCustomerId);

  const localStatus = m?.__local?.status as string | undefined;
  const isFailed = localStatus === "failed";

  return (
    <Box key={String(id)} mb="24px">
      {!isMine ? (
        <Flex align="center" gap="8px" mb="8px">
          <Box as="img" src={SupportUsersIcon} alt="Support" w="16px" h="16px" borderRadius="25px" bg="#F5F7FA" />
          <Text fontSize="14px" fontWeight="400" color="#0B0E10">
            {otherPartyLabel ?? "Support"}
          </Text>
          {displayTime ? (
            <Text fontSize="14px" color="#9CA3AF">
              {displayTime}
            </Text>
          ) : null}
        </Flex>
      ) : (
        <Flex align="center" justify="flex-end" mb="6px">
          {displayTime ? (
            <Text fontSize={isMine ? "12px" : "14px"} color="#9BA3A7">
              {displayTime}
            </Text>
          ) : null}
        </Flex>
      )}

      <Flex justify={isMine ? "flex-end" : "flex-start"}>
        <Box
          maxW="70%"
          bg={isFailed ? "#FEF2F2" : isMine ? "#F5F9FF" : "#F5F7FA"}
          borderRadius={!isMine ? "16px" : "25px"}
          px="16px"
          py="8px"
        >
          {isMine && isFailed && onRetrySend && m?.client_id ? (
            <MessageFailedStatus clientId={String(m.client_id)} onRetrySend={onRetrySend} />
          ) : null}

          <Text fontSize="16px" lineHeight="1.3129" color="#0B0E10" whiteSpace="pre-wrap">
            {body}
          </Text>

          {Array.isArray(m?.attachments) && m.attachments.length > 0 ? (
            <MessageAttachments
              messageId={String(id)}
              attachments={m.attachments}
              getDisplayName={getDisplayName}
              onDownload={onDownload}
            />
          ) : null}
        </Box>
      </Flex>
    </Box>
  );
});
